export const DEFAULT = 'default';
export const TEXT = 'text';

export const TYPE_LIST = [DEFAULT, TEXT];
